import { render, staticRenderFns } from "./NotificationScreen.vue?vue&type=template&id=bcb69734"
import script from "./NotificationScreen.vue?vue&type=script&lang=js"
export * from "./NotificationScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports